import * as React from 'react';
import { Dots } from 'react-activity';
import styled from 'styled-components';
import CreditDisplay from '../CreditDisplay';

import IViewProps from '../../IViewProps';
import CardWithHeader from '../CardWithHeader';
import RewardCategoryItem from './RewardCategoryItem';
import Menu from '../Menu';
import { groupBy } from 'lodash';
import Colors from '../../lib/Colors';

function UnstyledRewardCategoryList(props: IViewProps) {
  const s1 = 'https://tvsmiles.zendesk.com/hc/de/articles/';
  const s2 = '360019835979-Smiles-Shop-Wiederer%C3%B6ffnung-im-Februar-2021';
  const supportUrl = `${s1}${s2}`;
  // only display active categories with at least one active reward
  const rewardsByCategory = groupBy(props.rewards.filter(r => r.isActive), 'rewardCategoryId');
  const rewardCategories = props.rewardCategories
        .filter(category =>
            ((category.isVip && props.vipCredits! >= 2200)
            || (!category.isVip && props.vipCredits! < 2200)) &&
            category.isActive &&
            rewardsByCategory[category.id] &&
            rewardsByCategory[category.id].length > 0);
  const isLoaded = rewardCategories.length > 0;
  const menuOrTitle = props.isAuthenticated
  ? <>
      <Menu
          appMode={props.appMode}
          showRewardCategoryList={props.onShowRewardCategoryList}
        showPurchaseHistory={props.onShowPurchaseHistory}
      ></Menu>
      <CreditDisplay label="Prämien Smiles:" amount={props.credits!}/>
    </>
  : 'Prämie Wählen';
  return (
    <CardWithHeader
      title={menuOrTitle}
      className={props.className}
      onGoBack={props.onCloseApp}
    >
      {isLoaded && (
        <>
        <ul className="reward-categories">
          {rewardCategories
              .map(rewardCategory => (
                  rewardCategory.isActive
                  ? <li key={rewardCategory.id}>
                    <RewardCategoryItem
                      rewardCategory={rewardCategory}
                      onClick={() => props.onSelectRewardCategory(rewardCategory.id)}
                    />
                  </li>
                  : null
          ))}
        </ul><hr/>
        <section className="description"><p>04.03.2025 Der Shop ist wieder geöffnet und alle
            Bestellungen werden zeitnah ausgeliefert.<br/>Uns ist bekannt, dass einige Nutzer
            leider beim Versuch zu bestellen eine Fehlermeldung erhalten haben. Wir arbeiten
            an einer Lösung und bitten um Geduld.
            </p>
            <p><a href={supportUrl}>
                Hier kannst Du alles zu den neuen Einlösebedingungen lesen.</a></p>
            <hr/>
            {props.vipCredits! > 0 ?
                <p>Du hast aktuell {props.vipCredits!} Treue Status Smiles. Darin enthalten sind
                    früher gesammelte Smiles und Gutschriften aus früheren Bestellungen. Hierfür
                    erhältst Du die vergünstigten Treue Angebot im Shop.</p>
                :
                <p></p>
            }
            {props.isAuthenticated ? <p>Du hast aktuell {props.credits} Prämien Smiles. Diese kannst
                Du hier gegen eine Prämie einlösen.</p> : <></>}
        </section>
        </>
      )}

      {!isLoaded && (
        <section className={`${props.className} is-loading`}>
          <header>
            <Dots size={30} />
          </header>
        </section>
      )}
    </CardWithHeader>
  );
}

const RewardCategoryList = styled(UnstyledRewardCategoryList)`
  ul.reward-categories {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display:flex;
    flex-wrap:wrap;
    li{
      flex:1 100%;
    }
  }
  &.is-loading {
    header {
      min-height: 10rem;
    }
    header,
    footer {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 1rem;
    }
  }

  @media screen and (min-width:600px) {
    ul.reward-categories li{
      flex:1 50%;
    }
  }

  section.description {
    padding: 0.5rem 1.2rem;
    font-size: 0.9rem;
    line-height: 1.333;
    color: ${Colors.mutedText};
  }
`;
export default RewardCategoryList;



// WEBPACK FOOTER //
// ./src/components/RewardCategoryList/RewardCategoryList.tsx